// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { GridOffset } from "@werner/MobiusOverrides/GridContainer/GridContainer";
import { color, mergeWithCss, xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.container = {
    css: css`
        ${GridOffset} {
            justify-content: space-between;
            align-items: center;
            flex-wrap: nowrap;
            ${xScreen("lte", "sm")} {
                flex-wrap: wrap;
            }
        }
    `,
};

productSelectorStyles.clearIcon = {
    ...mergeWithCss(productSelectorStyles.clearIcon, {
        size: 14,
        css: css`
            right: 62px;
            top: 43px;
            &:hover {
                color: ${color("primary")};
            }
        `,
    }),
};

productSelectorStyles.buttonGridItem = {
    ...productSelectorStyles.buttonGridItem,
    css: css`
        justify-content: flex-end;
    `,
};

productSelectorStyles.qtyGridItem = {
    width: [2, 2, 1, 1, 1],
    css: css`
        min-width: 100px;
        & input {
            padding-left: 10px !important;
            padding-right: 10px !important;
            text-align: center;
            max-width: 100px;
        }
    `,
};

productSelectorStyles.unitOfMeasureGridItem = {
    width: [8, 8, 3, 3, 3],
};

productSelectorStyles.searchGridItem = {
    width: [12, 12, 5, 5, 5],
        css: css`
            position: relative;
        `,
};

productSelectorStyles.selectButton = {
    css: css`
        min-width: 150px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "max",
        )}
    `,
};